import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PageHeader from "../../components/PageHeader";
import CriSection from "../../components/CriSection";
import HeaderPhoto from "../../assets/images/generic_midwest.jpg";
import ContactCard, { ContactCardProps } from "./ContactCard";
import { Key } from "react";

const Contacts: ContactCardProps[] = [
  {
    name: "Margot Mazur",
    email: "consresearchinst.mazur@gmail.com",
    phone: "(262) 909-0552",
    position: "Executive Director",
    address: "P.O. Box 1848, Sandpoint, ID 83864",
  },
  {
    name: "Dr. Gerould Wilhelm",
    email: "consresearchinst.wilhelm@gmail.com",
    phone: "(630) 640-1402",
    position: "Director of Research",
    address: "P.O. Box 1848, Sandpoint, ID 83864",
  },
  {
    name: "Kenneth Johnson",
    email: "consresearchinst.johnson@gmail.com",
    phone: "(630) 640-2169",
    position: "Research Associate",
    address: "403 W. St. Charles Road, Lombard, IL 60148",
  },
];

function Contact() {
  return (
    <Box>
      <PageHeader image={HeaderPhoto} title="Reach Out to the CRI Team" />

      <CriSection>
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: 300,
            textAlign: "center",
          }}
        >
          Contact Us
        </Typography>

        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          sx={{
            marginTop: "36px",
          }}
        >
          {Contacts.map(
            (contact: ContactCardProps, index: Key | null | undefined) => (
              <Grid size={{ xs: 12, md: 4 }} key={index}>
                <ContactCard {...contact} />
              </Grid>
            )
          )}
        </Grid>
      </CriSection>

      <CriSection alternate={true}>
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: 300,
            textAlign: "center",
          }}
        >
          Support our Team
        </Typography>

        <Typography
          sx={{
            fontWeight: 300,
            fontSize: "16px",
            lineHeight: 1.2,
            marginTop: "12px",
            marginBottom: "36px",
          }}
        >
          Thank you for visiting the Conservation Research Institute. CRI is
          pleased to offer an array of essays, white papers, and natural history
          monographs for all those interested in our culture’s relationship with
          the natural world. While we offer these free of expense to our
          colleagues and interested citizens, their production and the
          maintenance of our website involve a good bit of heart-felt labor and
          expense. As a not-for-profit 501-c3 organization, we appreciate any
          support you feel comfortable in providing.
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            sx={{
              paddingLeft: "100px",
              paddingRight: "100px",
              paddingTop: "18px",
              paddingBottom: "18px",
            }}
          >
            Make a Donation
          </Button>
        </Box>
      </CriSection>
    </Box>
  );
}

export default Contact;
